import { Modal } from '@mui/material';
import TopBar from '../Layout/TopBar';
import MyButton from '../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';

const css = {
    modal: {
        height: '100%',
        width: '100%',
    },
    container: {
        height: '35%',
        width: '30%',
        backgroundColor: 'white',
        borderRadius: '5px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    fullRow: {
        height: '100%',
        width: '100%',
        alignItems: 'center',
    },
    row: {
        height: 'calc(100% - 110px)',
        flexDirection: 'column',
        justifyContent: 'normal',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px'
    },
    modalSpan: {
        marginBottom: '10px'
    }
};

const ModalDeleteRequestConfirmation = (props) => {
    const { openModal, setOpenModal, dossier, setNeedReload } = props;
    const alert = useAlert();
    const [isLoading, setIsLoading] = useState(false);

    const handleCloseModal = () => {
        if (setNeedReload) {
            setNeedReload(true);
        }
        setIsLoading(false);
        setOpenModal(false);
    };

    const confirmDeleteRequest = async () => {
        await apiDeleteRequest();
        handleCloseModal();
    };

    const apiDeleteRequest = async () => {
        setIsLoading(true);
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/delete-request`,
            params: { requestPassId: dossier.id },
        })
        .then((response) => {
            alert.removeAll();
            alert.success('Dossier supprimé avec succès');
            setIsLoading(false);
        })
        .catch((error) => {
            logError(alert, error);
            setIsLoading(false);
        });
    };

    return (<Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
        <div className='modal' style={css.modal}>
            <div style={css.container}>
                <TopBar title={`Suppression du dossier [N°${dossier.id}]`} className='topbar-contenu' color='#0094ca' />

                {isLoading && <div className='row'>
                    <ClipLoader color='#0094ca' loading={isLoading} size={75}
                                css={'display: flex; margin: 25px;justify-content: center;'} />
                </div>}

                <div style={css.modalContent}>
                    <span style={css.modalSpan}>Êtes-vous sûr de vouloir supprimer ce dossier ?</span>
                    <span>Cette action est irréversible</span>
                </div>

                <div>
                    <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} />
                    <MyButton onClick={() => confirmDeleteRequest()} label='Confirmer' icon={faCheck}></MyButton>
                </div>
            </div>
        </div>
    </Modal>);
};

export default ModalDeleteRequestConfirmation;
